import { DeviceModel } from './types'

/**
 * Catalog models that match a USB device: exact vendor + product first, then vendor only. Generic models (no `match`)
 * are offered after these, so an unknown device can still be used.
 */
export const matchUsb = (models: DeviceModel[], vendorId?: number, productId?: number): DeviceModel[] => {
  if (vendorId === undefined) return []
  const exact = models.filter((m) => m.match?.usb?.some((u) => u.vendor_id === vendorId && u.product_id === productId))
  const vendor = models.filter(
    (m) => !exact.includes(m) && m.match?.usb?.some((u) => u.vendor_id === vendorId && u.product_id === undefined)
  )
  return [...exact, ...vendor]
}

/** Vendor ids the catalog knows, to filter the browser's device picker. */
export const knownVendors = (models: DeviceModel[]) => [
  ...new Set(models.flatMap((m) => m.match?.usb?.map((u) => u.vendor_id) ?? [])),
]
